<div>
<img [src]="image" #croppie="croppie" [mtgCroppie]="config" *ngIf="image">
</div>
<button class="btn btn-link" (click)="save()">{{ localization | mtgTranslate: 'download' }}</button>
